
export const HelpText =
[
    {
        "subject": "Medname",
        "title": "Medication Name",
        "content": ["Enter the name of your medication. As you enter the name, a list of potential matches will appear, if any. ",
            "If you see your medication name, you may select it, otherwise you can continue entering the name. ",
            "As you type, your entry will appear as the top name in the list. ",
            "Once you have fully entered the name, select it from the list. ",
            ""
            ]
    },
    {
        "subject": "Medbrand",
        "title": "Medication Brand",
        "content": ["Enter the brand name of your medication, if known. ",
            "As you enter the brand name, a list of potential matches will appear, if any. ",
            "If you see your brand name, you may select it, otherwise you can continue entering the name. ",
            "As you type, your entry will appear as the top name in the list. ",
            "Once you have fully entered the name, select it from the list. If the brand name is not known, selece 'Not Listed'.",
            ""
            ]
    },
    {
        "subject": "Medtype",
        "title": "Medication Type",
        "content": ["Select the type of medication from the list.",
            "",
            ""
            ]
    },
    {
        "subject": "Medform",
        "title": "Medication Form",
        "content": ["Select the form of the medication from the list. ",
            "For known medications, the available forms will be presented, otherwise a generic list will be presented. ",
            ""
            ]
    },
    {
        "subject": "Medstrength",
        "title": "Medication Strength",
        "content": ["For known medications, a list of standard strengths is presented. ",
            "Select one if the standard values (if available) or enter a value manually. ",
            ""
            ]
    },
    {
        "subject": "Meddosage",
        "title": "Medication Dosage",
        "content": ["Select the quantity of your medication that you take each time. ",
            "If the quantity is not in the list, enter it manually.",
            ""
            ]
    },
    {
        "subject": "Medoften",
        "title": "Medication Occurance",
        "content": ["Select how often you take your medication. "
            ]
    },
    {
        "subject": "Medhourly",
        "title": "Hourly Medication",
        "content": ["Choose the number of hours between each time you take your medication. ",
            "Reminders to take your medication will be scheduled starting with your Awake Time, ",
            "and then every selected hours up until your Bed Time.",
            ""
            ]
    },
    {
        "subject": "Meddaily",
        "title": "Medication Taken Daily",
        "content": ["Select the number of times each day that you take your medication. ",
            ""
            ]
    },
    {
        "subject": "Medeveryndays",
        "title": "Taken Every ? Days",
        "content": ["",
            ""
            ]
    },
    {
        "subject": "Medweekly",
        "title": "Taken Weekly",
        "content": ["",
            ""
            ]
    },
    {
        "subject": "Medweekdays",
        "title": "Taken on Certain Days",
        "content": ["",
            ""
            ]
    },
    {
        "subject": "Medschedule",
        "title": "Schedule",
        "content": ["",
            ""
            ]
    },
    {
        "subject": "Medsearch",
        "title": "",
        "content": ["",
            ""
            ]
    },
    {
        "subject": "Medconfirm",
        "title": "",
        "content": ["Confirm New Medication",
            ""
            ]
    },
    {
        "subject": "ExportMeds",
        "title": "Export Medication List",
        "content": ["<b>Save Medication List</b><br />",
            "This will save a printable list of your medications to a text file named 'medication-list.txt' in your 'download' directory.\n",
            "<b>Email Medication List</b><br />",
            "This will send a printable list of your medications to the email address provided. ",
            ""
            ]
    },
    {
    "subject": "ExportHist",
    "title": "Export Medication History",
    "content": ["<b>Save History List</b><br />",
        "This will save a CSV formatted list of your medication history to a file named 'history-list.csv' in your 'download' directory.\n",
        "<b>Email Medication List</b><br />",
        "This will send a csv formatted list of your medication history to the email address provided.",
        ""
        ]
    },
    {
        "subject": "ExportData",
        "title": "Export Data",
        "content": ["<b>Export Printable Medication List</b><br />",
            "Save or Email a printable list of your medications.\n",
            "<b>Export History Data (CSV)</b><br />",
            "Save or Email a CSV formatted list of your medication history. ",
            ""
            ]
    }
];

function formatContent(text) {
    var content = "<p>" +text.join("") + "</p>";
    content = content.replaceAll("\n", "</p><p>");
    return content;
}

export function getHelpText(subject) {
    let help = {
        title: "No Title",
        text: "No content for subject: " + subject
    }
    for(var ht of HelpText) {
        if (ht.subject === subject) {
            help = {
                title: ht.title === "" ? subject : ht.title,
                text: formatContent(ht.content)
            }
            break;
        }
    }
    return (help);
}
